import React, { Component, Fragment } from 'react';

import PropTypes from 'prop-types';

import {
  connect
} from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  SongRow
} from '../../components';

import {
  FavoriteH1,
  CitTable
} from '../../components/HelperComponents/StyledComponents';

import {
  SongTableHeader
} from '../../components/HelperComponents/HelperComponents';

import {
  playlistReplace,
} from '../../actions/PlaylistActions';

import {
  getSonglistHash,
} from '../../helpers';

const getSongsFromFavProps = props => {
  return (props.favorites && props.favorites.items && props.favorites_other && props.favorites_other.items) || [];
};

class FavoritesComponent extends Component {
  static propTypes = {
    children: PropTypes.any,
    match: PropTypes.any,
    location: PropTypes.any,
    history: PropTypes.any,
    user: PropTypes.object
  };

  componentDidMount() {
    if (!this.props.user.authenticated) {
      return this.props.history.push('/');
    }
  }

  componentDidUpdate(prevProps) {
      // console.log('change1');
      // console.log(this.props.history);
      // const ch=this.props.history;
      // console.log('change2');
      // console.log(ch);
      // if(typeof ch.location!='undefined') {
      //   if(typeof ch.location.search!='undefined') {
      //     const inc=ch.location.search;
      //     console.log(inc);
      //     if(inc!='') { if(inc.includes('list')) this.checkForUpdatedSongs(this.props, prevProps, true); }
      //   }
      // }
      // else 
      this.checkForUpdatedSongs(this.props, prevProps);
  }

  checkForUpdatedSongs(props, prevProps, other=false) {

    const songs = getSongsFromFavProps(props);
    const songsPrev = getSongsFromFavProps(prevProps);
    console.log(getSonglistHash(songs));
    console.log(getSonglistHash(songsPrev));

      if (getSonglistHash(songs) !== getSonglistHash(songsPrev)) {
        this.props.playlistReplace(songs);
    }
  }

  render() {

    const currentSongId = this.props.currentSong && this.props.currentSong.id;

    const uid=this.props.user.data.user_id;
    const viola_url='https://www.voilacatalog.com/favorites';
    // const viola_url='http://52.200.144.109:3006/favorites';
    const playlist_url=viola_url+'?list='+uid;
    const current_url=window.location.href;
    const uid_from_url=''+current_url.replace(viola_url+'?list=', '');
   
    const user_name=uid_from_url!=''&&uid_from_url!=viola_url ? (typeof(this.props.favorites_other.uname)=='undefined' ? '' : this.props.favorites_other.uname+"'s") : 'My';
    const songs = uid_from_url!=''&&uid_from_url!=viola_url ? (this.props.favorites_other.items || []) : (this.props.favorites.items || []);
    const is_other_user = uid_from_url!=''&&uid_from_url!=viola_url ? true : false;

    setTimeout(function(){
      if(document.getElementById("show_loading")&&is_other_user) {
        window.location.reload();
      }
    }, 9000); 
    //const songs = this.props.favorites.items || [];
    document.body.classList.add('is_album');
    const allSongs = songs.map((cov, i) => {
      const song = cov ? cov : {};
      const isActive = song.id && song.id === currentSongId;
      const isLoading = isActive && this.props.isLoading;
      const isPlaying = isActive && this.props.isPlaying;
      return (
        <SongRow
          key={'songRow_favorite' + i}
          song={song}
          numeration={i}
          isActive={isActive}
          isLoading={isLoading}
          isPlaying={isPlaying}
          shouldShowAlbumCover={true}
          shouldLinkAlbumTitle={true}
      />)
    });
    console.log('######');
    console.log(allSongs);
    console.log();
    const show_loading=allSongs.length==0&&is_other_user&&this.props.favorites_other.isFetching!=false ? true : false;

    return (
      <Fragment>
        <section className="column is-11">
          <FavoriteH1>
            {user_name} Favorites
          </FavoriteH1>

          <CitTable className="table favs is-fullwidth has-text-white" theme={{ tableRowBackgroundColor: '#191919' }}>
            <SongTableHeader/>
            <tbody className="is-hoverable">
              {allSongs}
            </tbody>
          </CitTable>
            {show_loading &&
            <div id="show_loading" className="show_loading"><div className="lds-load"><div></div><div></div><div></div></div></div>
            }
        </section>
        <section className="column is-11">
          <FavoriteH1>
            Share Your Favorites
          </FavoriteH1>

          <div className="is-hoverable fav_share is-fullwidth has-text-white">
            Copy and share this link: <pre id="copy_playlist"  onClick={() => {
                 var inp =document.createElement('input');
                  document.body.appendChild(inp);
                  inp.value =playlist_url;
                  inp.select();
                  document.execCommand('copy',false);
                  inp.remove();
                  document.getElementById('clipboard_info_hide').style.display = 'inline-block';
                }}>{playlist_url}</pre><span id="clipboard_info_hide">Link copied to your clipboard!</span><small>(Note: Playlist will be available for logged-in users only)</small>
            </div>
        </section>
      </Fragment>
    );
  }
}


const getVisibleResults = (results, filter) => {
  if (!filter) return results;

  let filteredResults = results.filter((res) => {
    let isValid = filter.every((fil, i) => {
      if (res[`product_${fil.type}`] && res[`product_${fil.type}`].length && res[`product_${fil.type}`].find((product, i) => product.slug === fil.filter || product.post_name === fil.filter)) {
        return true;
      } else {
        return false;
      }
    });

    return isValid;
  });

  return filteredResults;
}

function mapStateToProps(state) {
  const {
    user,
    filters,
    favorites,
    favorites_other,
    playerSong,
  } = state;

  let filtered = { ...favorites, items: [...getVisibleResults(favorites.items, filters.selected)] };
  let filtered2 = { ...favorites_other, items: [...getVisibleResults(favorites_other.items, filters.selected)] };
  let f1i=filtered.items;
  let f2i=filtered2.items;
  let f1=f1i.filter((ele, ind) => ind === f1i.findIndex( elem => elem.id === ele.id));
  let f2=f2i.filter((ele, ind) => ind === f2i.findIndex( elem => elem.id === ele.id));
  filtered.items=f1;
  filtered2.items=f2;
  console.log('filtered');
  console.log(filtered);
  console.log(f1);
  console.log(filtered2);
  console.log(f2);

  const {
    isPlaying,
    isLoading,
    currentSong,
  } = playerSong || {
    currentSong: null,
    isPlaying: false,
    isLoading: false,
  };

  return {
    favorites: filtered,
    favorites_other: filtered2,
    currentSong,
    isPlaying,
    isLoading,
    filters,
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    playlistReplace,
  }, dispatch);
}

export const Favorites = connect(mapStateToProps, mapDispatchToProps)(FavoritesComponent);



// WEBPACK FOOTER //
// ./src/routes/Favorites/Favorites.js